/// <reference path="../../../node_modules/@types/adal/index.d.ts" />
import { Injectable } from '@angular/core';
import 'expose-loader?AuthenticationContext!../../../node_modules/adal-angular/lib/adal.js';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs';
import { retry } from 'rxjs/operators';
import { config } from '../../config';


let createAuthContextFn: adal.AuthenticationContextStatic = AuthenticationContext;
@Injectable()

export class AdalService {
  azureAdConfig = {
    tenant: '078256a4-c4a0-4e95-b107-2ae7d5db8581',
    clientId: '75db915c-344c-4e36-a5f2-20925770c15b',
    redirectUri: config.AzureADUrl + 'dashboard',
    postLogoutRedirectUri:config.AzureADUrl + 'login',
    navigateToLoginRequestUrl: false,
    cacheLocation: 'localStorage'
  };
  private context: adal.AuthenticationContext;  

  constructor() {
    this.context = new createAuthContextFn(this.azureAdConfig);
  }

  public login_userhint(loginid: string) {
    this.context.config.extraQueryParameter = 'login_hint=' + loginid;
    this.context.login();
  }

  login() {
    this.login_userhint(localStorage.getItem('emailid'));
  }

  logout() {
    this.context.logOut();
  }

  handleCallback() {
    this.context.handleWindowCallback();
  }

  acquireToken(resource, callback) {
    return this.context.acquireToken(resource, callback);
  }

  public getCachedToken(resource?) {
    if (resource) {
      return this.context.getCachedToken(resource);
    }
    return this.context.getCachedToken(this.azureAdConfig.clientId);
  }

  public get userInfo() {
    return this.context.getCachedUser();
  }

  public get getCachedUser() {
    return this.context.getCachedUser();
  }

  public get isAuthenticated() {
    return this.userInfo && this.getCachedToken();
  }
  public acquireTokenResilient(resource: string): Observable<any> {
    return new Observable<any>((subscriber: Subscriber<any>) =>
      this.context.acquireToken(resource, (_message: string, token: string) => {
        if (token) {
          subscriber.next(token);
        } else {
          window.location.href = "/login";
        }
      })
    ).pipe(retry(3))
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/adal.service.ts